import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useStyles } from './Footer.styles';
import { Grid } from '@material-ui/core';
import { Typography } from 'components';
import { TEXT } from 'texts';

type FooterProps = {};

const Footer: React.FC<FooterProps> = () => {
  const styles = useStyles();
  const { t } = useTranslation();

  return (
    <footer>
      <Grid container alignItems="center" justifyContent="center" className={styles.footer}>
        <Typography align="center" textColor="grey" textType="smallText">{t(TEXT.copyright)}</Typography>
      </Grid>
    </footer>
  );
};

export default Footer;